import { PATH_TENANT_BASE } from '../constants'

export const tenantRouterPath = (slug?: string) => {
  return slug === undefined || slug.length <= 1 ? PATH_TENANT_BASE : PATH_TENANT_BASE + slug
}
